import ProfileParams from '@root/auto-pricing/src/models/profile-params';
import PropTypes from '@root/vendor/prop-types';
import QuotesContext from '@root/quotes/src/models/quotes-context';
import SceneContent from '@root/core/src/components/scene-content';
import SceneWrapper from '@root/core/src/components/scene-wrapper';
import TimeDelayInfo from '@root/quotes/src/components/time-delay-info';
import UnderwritingManualReviewLayout from '@root/quotes/src/components/underwriting-manual-review-layout';
import UnderwritingPendingLayout from '@root/quotes/src/components/underwriting-pending-layout';

export default function UnderwritingPendingEntry({
  quotesContext,
  analyticsContext,
  profileParams,
}) {
  const conditions = quotesContext?.underwritingDecision?.conditions;

  if (quotesContext?.underwritingDecision?.moratoriumDetails?.delayed) {
    return (
      <SceneWrapper>
        <SceneContent>
          <TimeDelayInfo
            estimatedCompletionDate={quotesContext.underwritingDecision.moratoriumDetails.estimatedCompletionDate}
          />
        </SceneContent>
      </SceneWrapper>
    );
  } else if (conditions?.find((condition) => condition.code === 'UNDER_REVIEW')) {
    return (
      <UnderwritingPendingLayout
        analyticsContext={analyticsContext}
        profileParams={profileParams}
        quotesContext={quotesContext}
      />
    );
  } else {
    return (
      <UnderwritingManualReviewLayout
        analyticsContext={analyticsContext}
        quotesContext={quotesContext}
      />
    );
  }
}

UnderwritingPendingEntry.propTypes = {
  analyticsContext: PropTypes.string.isRequired,
  profileParams: PropTypes.instanceOf(ProfileParams).isRequired,
  quotesContext: PropTypes.instanceOf(QuotesContext).isRequired,
};
